module.exports = "/wwwroot/img/channel_info_block.png?ver=d8f9ee11";